import angular from 'angular';
import olLayerImage from 'ol/layer/Image';
import olSourceImageWMS from 'ol/source/ImageWMS';
import olGeomPoint from 'ol/geom/Point'

/**
 * @type {angular.IModule}
 * @hidden
 */
const myModule = angular.module(
  'apronaRechargeFormComponent',
  []
);

myModule.run(
  /**
   * @ngInject
   * @param {angular.ITemplateCacheService} $templateCache
   */
  ($templateCache) => {
    // @ts-ignore: webpack
    $templateCache.put('aprona/recharge/form', require('./formComponent.html'));
  }
);

myModule.value(
  'apronaRechargeFormTemplateUrl',
  /**
   * @param {angular.IAttributes} $attrs Attributes.
   * @returns {string} The template url.
   */
  ($attrs) => {
    const templateUrl = $attrs.apronaRechargeTemplateUrl;
    return templateUrl !== undefined ? templateUrl : 'aprona/recharge/form';
  },
);

/**
 * @param {angular.IAttributes} $attrs Attributes.
 * @param {function(angular.IAttributes): string} apronaRechargeTemplateUrl Template function.
 * @returns {string} Template URL.
 * @private
 * @hidden
 */
apronaRechargeFormTemplateUrl.$inject = ['$attrs', 'apronaRechargeFormTemplateUrl'];
function apronaRechargeFormTemplateUrl($attrs, apronaRechargeFormTemplateUrl) {
  return apronaRechargeFormTemplateUrl($attrs);
}

/**
 * @hidden
 */
export class Controller {
  /**
   * @param {angular.IScope} $scope Angular scope.
   * @param {import('gmf/theme/Themes').ThemesService} gmfThemes gmf Themes service.
   * @ngdoc controller
   * @ngname ApronaRechargeFormController
   */
  constructor($scope, gmfThemes) {

    // Binding properties

    /**
     * @type {Boolean}
     */
    this.active = false;

    /**
     * @type {?import('ol/Map').default}
     */
    this.map = null;

    /**
     * @type {?import('ol/geom/Point').default}
     */
    this.rechargePoint = null;

    // Injected properties

    /**
     * @type {angular.IScope}
     * @private
     */
    this.$scope_ = $scope;

    /**
     * @type {import('gmf/theme/Themes').ThemesService}
     */
    this.gmfThemes_ = gmfThemes;
  }

  /**
   * Called on initialization of the component.
   */
  $onInit() {
    this.map.on('click', (event) => this.handleMapClick(event));

    this.gmfThemes_.getOgcServersObject()
    .then((ogcServers) => {
      const ogcServer = ogcServers['source for image/png']
      this.createLayer(ogcServer);
    });
  }

  createLayer(ogcServer) {
    this.olSource = new olSourceImageWMS({
      url: ogcServer.url,
      params: {
        FORMAT: 'image/png',
        LAYERS: 'contour_rch',
        SERVERTYPE: 'mapserver',
        ogcserver: 'source for image/png'
      }
    });
    this.olSource.on('imageloadstart', () => {
      this.$scope_.$apply(() => {
        this.loading = true;
      })
    })
    this.olSource.on('imageloadend', () => {
      this.$scope_.$apply(() => {
        this.loading = false;
      })
    })

    this.olLayer = new olLayerImage({
      visible: false,
      source: this.olSource
    })
    this.olLayer.setZIndex(998);
    this.map.addLayer(this.olLayer);
  }

  /**
   * Called when some component attribute has changed.
   */
  $onChanges(changes) {
    if (changes.active) {
      if (this.olLayer) {
        this.olLayer.setVisible(changes.active.currentValue);
      }
      if (changes.active.currentValue == false) {
        this.rechargePoint = null;
      }
    }
  }

  /**
   * Handle map click event
   * @param {import('ol/MapBrowserEventType')} event The map browser event.
   */
  handleMapClick(event) {
    if (!event.originalEvent) {
      // not a MapBrowserEvent
      return;
    }

    if (!this.active) return

    const x = event.coordinate[0];
    const y = event.coordinate[1];

    this.rechargePoint = new olGeomPoint([x, y])

    this.$scope_.$apply();
  }
}

Controller.$inject = [
  '$scope',
  'gmfThemes',
];

myModule.component('apronaRechargeForm', {
  bindings: {
    'active': '<',
    'map': '<',
    'rechargePoint': '=',
  },
  controller: Controller,
  templateUrl: apronaRechargeFormTemplateUrl,
});

export default myModule;
